import { ValueGetterParams } from '@ag-grid-enterprise/all-modules';

export const ftpTypeValueGetter = ({ data }: ValueGetterParams): string => {
  return `Over ${data.FTPTYPE}`;
};

export const fileModeValueGetter = ({ data }: ValueGetterParams): string => {
  let value: string = 'Undefined';

  if (data.FILEMODE.toLocaleUpperCase() === 'ALLINONE') {
    value = 'CC for multiple targets per file';
  } else if (data.FILEMODE.toLocaleUpperCase() === 'CASE') {
    value = 'CC for one target per file';
  }
  return value;
};
